<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-undo text-primary mr-2"></i>
                    Ficha Devolucion
                </h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card>

                    <template v-if="bankReturn.code" slot="header">
                        <b-col class="d-flex flex-row justify-content-between">
                            <span><b>{{ bankReturn.code }}</b></span>
                            <span>{{ bankReturn.description }}</span>
                        </b-col>
                    </template>

                    <b-row>

                        <b-col>

                            <b-row>
                                <b-col>
                                    <b>Identificador del Documento:</b>
                                    <span v-if="!!bankReturn.documentHeaderId">
                                    {{ bankReturn.documentHeaderId }}
                                </span>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <b>Fecha del documento:</b>
                                    <span v-if="!!bankReturn.documentHeaderDate">
                                    {{ bankReturn.documentHeaderDate | dateFormat('DD/MM/YYYY') }}
                                </span>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <b>Sedes:</b>
                                    <span v-for="headquarters in bankReturn.headquarters">
                                    {{ headquarters }}
                                </span>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <b>Fecha Subida:</b>
                                    <span v-if="!!bankReturn.createdAt">
                                    {{ bankReturn.createdAt | dateFormat('DD/MM/YYYY')  }} 
                                </span>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <b>Importe (€):</b>
                                    <span v-if="!!bankReturn.amount"> {{ bankReturn.amount }}€</span>
                                    <span v-else> 0€</span>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="d-flex flex-row justify-content-end">
                            <div
                                v-if="!!bankReturn.seatsDiary"
                                class="ml-2">
                                <button class="btn btn-brand btn-primary btn-md" @click="getSeatsFiles()">
                                    Descargar Asientos
                                </button>
                            </div>
                        </b-col>
                    </b-row>

                </b-card>
            </b-col>

        </b-row>

        <b-row>
            <b-col>
                <b-card>
                    <div slot="header" class="d-flex justify-content-between align-content-center">
                        <div>
                            <template v-if="showAddReceiptsComponent">Añadir Recibos</template>
                            <template v-else>Recibos</template>
                        </div>
                        <div>
                            <button
                                :disabled="count<1"
                                class="btn btn-primary btn-sm mr-2"
                                @click="exportReceipts('csv')">
                                <i class="fa fa-download"></i> CSV
                            </button>
                            <button
                                :disabled="count<1"
                                class="btn btn-primary btn-sm"
                                @click="exportReceipts('xlsx')">
                                <i class="fa fa-download"></i> Excel
                            </button>
                            <button
                                :disabled="count<1"
                                class="btn btn-primary btn-sm ml-2"
                                @click="exportReceipts('pdf')">
                                <i class="fa fa-download"></i> PDF
                            </button>
                        </div>

                        <div v-if="!!bankReturn.type && bankReturn.isReturnType()">
                            <i
                                v-if="showAddReceiptsComponent"
                                v-b-tooltip.hover.top
                                title="Volver a listado"
                                class="fa fa-close pointer"
                                @click="showAddReceiptsComponent=false"></i>
                            <i
                                v-else
                                v-b-tooltip.hover.top
                                title="Añadir recibos"
                                class="fa fa-plus pointer"
                                @click="showAddReceiptsComponent=true"></i>
                        </div>
                    </div>

                    <template v-if="showAddReceiptsComponent">
                        <b-row>
                            <b-col>
                                <add-receipts-to-return-consignment
                                    v-model="bankReturn"
                                    :headquarters-id="bankReturn.headquarters.uuid"
                                    :presentation-date="bankReturn.presentationDate"></add-receipts-to-return-consignment>
                            </b-col>
                        </b-row>
                    </template>

                    <template v-else>
                        <b-row class="mb-4">
                            <b-col lg="3" md="6">
                                <b-form-input v-model="receiptFilters.code" placeholder="Código Recibo" class="mb-lg-0 mb-md-4 mb-sm-4 mb-xs-4" />
                            </b-col>

                            <b-col lg="3" md="6">
                                <periodicity-months-selector
                                    v-model="receiptFilters.periodicity"
                                    :allowEmpty="true" class="mb-lg-0 mb-md-4 mb-sm-4 mb-xs-4"></periodicity-months-selector>
                            </b-col>

                            <b-col lg="3" md="6">
                                <payment-method-selector
                                    v-model="receiptFilters.type"
                                    :allowEmpty="true" class="mb-lg-0 mb-sm-4 mb-xs-4"></payment-method-selector>
                            </b-col>

                            <b-col lg="3" md="6">
                                <cnae-selector
                                    v-model="receiptFilters.cnae"
                                    :allowEmpty="true"></cnae-selector>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <v-client-table
                                    ref="ReceiptsTable"
                                    class="dataTable"
                                    md="12"
                                    lg="12"
                                    sm="12"
                                    :columns="columns"
                                    :data="receipts"
                                    :options="options"
                                    :theme="theme">

                                   <template slot="select" slot-scope="props">
                                        <input type="checkbox" :value="props.row.uuid" v-model="selectedReceipts">
                                    </template>

                                    <!-- <template slot="uuid" slot-scope="props">
                                        <router-link
                                            v-if="mixinCheckPermission('RECEIPT_EDIT')"
                                            v-b-tooltip.hover.top
                                            title="Editar"
                                            :to="{ name: 'editReceipt', params: { uuid: props.row.uuid  }}">
                                            <i class="fa fa-pencil"></i>
                                        </router-link>

                                        <router-link
                                            v-else-if="mixinCheckPermission('RECEIPT_EDIT') || mixinCheckPermission('RECEIPT_LIST')"
                                            v-b-tooltip.hover.top
                                            title="Ver"
                                            :to="{ name: 'editReceipt', params: { uuid: props.row.uuid  }}">
                                            <i class="fa fa-eye"></i>
                                        </router-link>

                                        <button
                                            v-if="mixinCheckPermission('RECEIPT_DELETE')"
                                            v-b-tooltip.hover.top
                                            title="Eliminar"
                                            class="btn p-0 ml-1"
                                            @click="deleteReceipt(props.row.uuid)">
                                            <i class="fa fa-trash"></i>
                                        </button>

                                        <button
                                            v-if="mixinCheckPermission('RECEIPT_PRINT')"
                                            v-b-tooltip.hover.top
                                            title="Imprimir"
                                            class="btn p-0 ml-1"
                                            @click="openPrintReceiptModal(props.row.uuid)">
                                            <i class="fa fa-print"></i>
                                        </button>
                                    </template> -->

                                    <template slot="member" slot-scope="props">
                                        {{ props.row.member.fullName }}
                                    </template>

                                    <template slot="periodicity" slot-scope="props">
                                        <periodicity-name :value="props.row.periodicity.name"></periodicity-name>
                                    </template>

                                    <template slot="type" slot-scope="props">
                                        <payment-method-name :value="props.row.type"></payment-method-name>
                                    </template>

                                   

                                    <template slot="amount" slot-scope="props">
                                        {{ props.row.amount }} &euro;
                                    </template>

                                    <template slot="afterFilter">
                                        <b-row>
                                            <b-col>
                                                <consignment-overview-actions-selector
                                                    v-model="actionsSelector"
                                                    :allowEmpty="true"
                                                    :receipts="receipts"
                                                    :selectedReceipts="selectedReceipts"
                                                    :receiptDeletePermission="!!mixinCheckPermission('RECEIPT_DELETE')"
                                                    :blockDeleteReceipt="bankReturn.status === 'POSTED'"
                                                    @selected-action="selectedAction"></consignment-overview-actions-selector>
                                            </b-col>
                                            <b-col>
                                                <div v-if="!!selectedReceipts.length" class="selected-receipts"><i class="fa fa-check" aria-hidden="true"></i>Recibos seleccionados: <span class="number">{{ selectedReceipts.length }}</span></div>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </v-client-table>
                            </b-col>
                        </b-row>
                    </template>
                </b-card>
            </b-col>
        </b-row>

        <b-modal
            ref="printReceiptModal"
            hide-footer
            size="sm"
            title="Imprimir Recibo"
            class="text-center"
            @hidden="printReceiptModalClosed">
            <b-row>
                <b-col class="text-left">
                    <b-form-checkbox
                        type="checkbox"
                        stacked
                        v-model="receiptToPrint.specifyExpeditionDate"
                        name="hide">Especificar fecha de expedición
                    </b-form-checkbox>
                </b-col>
            </b-row>

            <b-row v-if="!!receiptToPrint.specifyExpeditionDate" class="mt-3">
                <b-col>
                    <v-date-picker
                        class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                        v-model="receiptToPrint.expeditionDate">
                    </v-date-picker>
                </b-col>
            </b-row>

            <b-row v-if="!!receiptToPrint.uuid" class="mt-3">
                <b-col class="d-flex flex-row-reverse">
                    <button
                        class="btn btn-brand btn-primary btn-lg"
                        :disabled="!!receiptToPrint.specifyExpeditionDate && !receiptToPrint.expeditionDate"
                        @click="printReceipt(receiptToPrint.uuid, receiptToPrint.expeditionDate)">
                        Imprimir
                    </button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {ClientTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import {
        getConsignment,
        issueConsignment,
        postConsignment,
        getConsignmentSeatsFiles,
        deleteConsignment
    } from '@/api/consignment-api';
    import {
        getBankReturn,
        getBankReturnSeatsFiles,
    } from '@/api/bank-return-api';
    import {getReceipts, deleteReceipt, deleteReceipts, printReceipt} from '@/api/receipt-api';
    import {getAttachmentPreview} from '@/api/attachment-api';
    import paymentMethodName from '@/components/clients/members/PaymentMethodName';
    import periodicityName from '@/components/periodicity/PeriodicityName';
    import periodicityMonthsSelector from '@/components/periodicity/PeriodicityMonthsSelector';
    import bankreturnOverviewActionsSelector from '@/components/actions/BankReturnOverviewActionsSelector';
    import paymentMethodSelector from '@/components/clients/members/PaymentMethodSelector';
    import cnaeSelector from '@/components/clients/cnaes/CnaeSelector';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import addReceiptsToReturnConsignment from './AddReceiptsToReturnBankReturn';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });
    Vue.use(ClientTable);

    export default {
        name: "bankReturnOverview",
        components: {
            ClientTable,
            Event,
            paymentMethodName,
            periodicityName,
            periodicityMonthsSelector,
            bankreturnOverviewActionsSelector,
            paymentMethodSelector,
            cnaeSelector,
            'v-date-picker': DatePicker,
            addReceiptsToReturnConsignment
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/accounting/bank-returns/list',
                        brand: 'fa fa-arrow-left'
                    }
                ],
                bankReturn: {
                    uuid: null
                },
                columns: ['select',/*  'uuid', */ 'code', 'member', 'periodicity', 'type', 'status', 'amount'],
                options: {
                    headings: {
                        select: {
                            text: ''
                        },
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        code: 'Código',
                        member: 'Socio',
                        periodicity: 'Periodicidad',
                        type: 'Tipo',
                        status: 'Estado',
                        amount: 'Cantidad'
                    },
                    columnsClasses: {
                        select: 'select',
                        uuid: 'fit'
                    },
                    sortable: ['code', 'member', 'periodicity', 'type', 'status', 'amount'],
                    filterable: [],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    perPageValues: [10, 25, 50, 100, 500, 1000],
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                theme: 'bootstrap4',
                receiptFilters: {
                    code: null,
                    periodicity: null,
                    type: null,
                    cnae: null
                },
                actionsSelector : null,
                receiptToPrint: {
                    uuid: null,
                    specifyExpeditionDate: false,
                    expeditionDate: null
                },
                showAddReceiptsComponent: false,
                selectedReceipts: [],
                isAllReceiptsSelected: false
            }
        },
        created() {
            this.count = 0;
            if (!this.$route.params.uuid) {
                this.$router.push({path: '/accounting/bank-returns/list'});
            }
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getBankReturn(this.$route.params.uuid);
            this.options.texts = form.tableLabels();
        },
        computed: {
            receipts() {
                if (Array.isArray(this.bankReturn.receipts)) {
                    let receipts = this.bankReturn.receipts;

                    if (!!this.receiptFilters.code) {
                        receipts = receipts.filter(receipt => (receipt.code.includes(this.receiptFilters.code)));
                        this.deselectAllReceipts();
                    }

                    if (!!this.receiptFilters.periodicity) {
                        receipts = receipts.filter(receipt => (receipt.periodicity.months === this.receiptFilters.periodicity));
                        this.deselectAllReceipts();
                    }

                    if (!!this.receiptFilters.type) {
                        receipts = receipts.filter(receipt => (receipt.type === this.receiptFilters.type));
                        this.deselectAllReceipts();
                    }

                    if (!!this.receiptFilters.cnae) {
                        let excludedReceipts = [];
                        receipts.forEach(receipt => {
                            if ( receipt.member.cnaes.length == 0 || !!(receipt.member.cnaes.find(cnae => cnae.uuid !== this.receiptFilters.cnae.uuid)) ) {
                                excludedReceipts.push(receipt);
                            }
                        });
                        receipts = receipts.filter(receipt => !excludedReceipts.includes(receipt));
                    }
                    this.count = receipts.length
                    return receipts;
                } else {
                    return [];
                }
            }
        },
        methods: {
            async exportReceipts(format) {
                if (this.count > 0) {
                    this.$_loadingMixin_showLoading();

                    let parameters = Object.assign({}, this.searchData);
                    parameters.page = 1;
                    parameters.itemsPerPage = this.count;

                    let response = await getReceipts(parameters);

                    let rows = response.receipts.map((receipt) => {
                        return this.normalizeReceipts(receipt);
                    });

                    if (format === 'csv') {
                        downloadJsonAsCsv(rows);
                    } else if (format === 'xlsx') {
                        downloadJsonAsXlsx(rows);
                    } else if (format === 'pdf') {
                        downloadJsonAsPdf(rows);
                    }

                    this.$_loadingMixin_hideLoading();
                }
            },
            normalizeReceipts(bankReturn) {
                return {
                    'Código': receipt.code,
                    'Socio': receipt.member.fullName,
                    'Periodicidad': receipt.periodicity,
                    'Estado': receipt.status,
                    'Tipo': recipt.type,
                    'Cantidad': receipt.amount,
                };
            },
            async getBankReturn(bankReturnId) {
                this.$_loadingMixin_showLoading();
                await getBankReturn(bankReturnId)
                    .then((bankReturn) => {
                        this.bankReturn = bankReturn;
                    });
                this.$_loadingMixin_hideLoading();
            },
            selectedAction(action) {
                switch (action.value) {
                    case 'Seleccionar todos':
                        this.selectReceipts();
                        break;
                    case 'Deseleccionar todos':
                        this.deselectAllReceipts();
                        break;
                    case 'Eliminar':
                        this.deleteReceipts(this.selectedReceipts);
                        break;
                }
            },
            selectReceipts() {
                this.selectedReceipts = []
                if (!this.isAllReceiptsSelected) {
                    for (let i in this.receipts) {
                        this.selectedReceipts.push(this.receipts[i].uuid);
                    }
                }
            },
            deselectAllReceipts() {
                this.selectedReceipts = [];
            },
            issueConsignment() {
                swal({
                    title: '¿Desea remesar la remesa?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                    cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                    reverseButtons: true
                }).then((response) => {
                    if (!!response.value) {
                        this.$_loadingMixin_showLoading();
                        issueConsignment(this.bankReturn.uuid)
                            .then((consignment) => {
                                this.bankReturn = consignment;
                                this.$_notificationMixin_success('Operación completada', 'Se ha remesado con éxito');
                                this.$_loadingMixin_hideLoading();
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Error en la operación', 'No se ha podido remesar');
                                this.$_loadingMixin_hideLoading();
                            });
                    }
                });
            },
            deleteReceipt(uuid) {
                swal({
                    title: '¿Desea eliminar el recibo?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                    cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                    reverseButtons: true
                }).then((response) => {
                    if (!!response.value) {
                        this.$_loadingMixin_showLoading();
                        deleteReceipt(uuid)
                            .then(() => {
                                this.removeReceiptFromReceipts(uuid);
                                this.deselectAllReceipts();
                                this.$_notificationMixin_success('Operación completada', 'El recibo ha sido eliminado');
                                this.$_loadingMixin_hideLoading();
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Error en la operación', 'No se ha podido eliminar el recibo');
                                this.$_loadingMixin_hideLoading();
                            });
                    }
                });
            },
            removeReceiptFromReceipts(uuid) {
                if (!!this.bankReturn.receipts) {
                    let index = this.bankReturn.receipts.findIndex(receipt => receipt.uuid === uuid);
                    this.bankReturn.receipts.splice(index, 1);
                }
            },
            deleteReceipts(uuids) {
                let partialTitle = (uuids.length == 1) ? 'el recibo seleccionado' : uuids.length + ' recibos';
                let successfulMessage = (uuids.length == 1) ? 'El recibo ha sido eliminado' : uuids.length + ' recibos han sido eliminados';
                let errorMessage = (uuids.length == 1) ? 'No se ha podido eliminar el recibo' : 'No se han podido eliminar los recibos';
                document.activeElement.blur();
                swal({
                    title: '¿Desea eliminar ' + partialTitle + '?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                    cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                    reverseButtons: true
                }).then((response) => {
                    if (!!response.value) {
                        this.$_loadingMixin_showLoading();
                        deleteReceipts(uuids)
                            .then(() => {
                                this.removeReceiptsFromReceipts(uuids);
                                this.deselectAllReceipts();
                                this.$_notificationMixin_success('Operación completada', successfulMessage);
                                this.$_loadingMixin_hideLoading();
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Error en la operación', errorMessage);
                                this.$_loadingMixin_hideLoading();
                            });
                    }
                });
            },
            removeReceiptsFromReceipts(uuids) {
                if (!!this.bankReturn.receipts) {
                    uuids.forEach(uuid => {
                        this.removeReceiptFromReceipts(uuid);
                    });
                }
            },
            async previewSepaXml() {
                this.$_loadingMixin_showLoading();
                await getAttachmentPreview(this.bankReturn.sepaXml, {type: 'application/xml'})
                    .then((dataStream) => {
                        const file = new Blob([dataStream]);
                        const fileURL = URL.createObjectURL(file);
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(file);
                        link.download = this.bankReturn.uuid + '.xml';
                        link.click();
                        URL.revokeObjectURL(link.href);
                    })
                    .catch(() => {
                        this.$_notificationMixin_error("Se ha producido un error", "No hemos podido recuperar la previsualización del documento");
                    });
                this.$_loadingMixin_hideLoading();
            },
            async printReceipt(uuid, expeditionDate) {
                this.$_loadingMixin_showLoading();
                let date = !!expeditionDate ? expeditionDate.toISOString() : null;
                await printReceipt(uuid, date)
                    .then((dataStream) => {
                        window.open(URL.createObjectURL(dataStream));
                    })
                    .catch(() => {
                        this.$_notificationMixin_error("Se ha producido un error", "No hemos podido recuperar la previsualización del documento");
                    });
                this.$_loadingMixin_hideLoading();
            },
            openPrintReceiptModal(uuid) {
                this.receiptToPrint.uuid = uuid;
                this.$refs.printReceiptModal.show();
            },
            printReceiptModalClosed() {
                this.receiptToPrint.uuid = null;
                this.receiptToPrint.specifyExpeditionDate = false;
                this.receiptToPrint.expeditionDate = null;
            },
            postConsignment() {
                swal({
                    title: '¿Desea contabilizar la remesa?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                    cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                    reverseButtons: true
                }).then((response) => {
                    if (!!response.value) {
                        this.$_loadingMixin_showLoading();
                        postConsignment(this.bankReturn.uuid)
                            .then((consignment) => {
                                this.bankReturn = consignment;
                                this.$_notificationMixin_success('Operación completada', 'Se ha contabilizado con éxito');
                                this.$_loadingMixin_hideLoading();
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Error en la operación', 'No se ha podido contabilizar');
                                this.$_loadingMixin_hideLoading();
                            });
                    }
                });
            },
            async getSeatsFiles() {
                try {
                    this.$_loadingMixin_showLoading();
                    let downloadLink = document.createElement('a');
                    document.body.appendChild(downloadLink);
                    downloadLink.style = "display: none";

                    let bankReturnHeadquarters = '';
                    for (var i = 0; i < this.bankReturn.headquarters.length; i++) {
                        bankReturnHeadquarters = bankReturnHeadquarters + this.bankReturn.headquarters[i];
                    }

                    const dataStream = await getBankReturnSeatsFiles(this.bankReturn.uuid)
                    const file = new Blob([dataStream], {type: 'application/zip'});
                    const fileURL = URL.createObjectURL(file);
                    downloadLink.href = fileURL;
                    downloadLink.download = this.bankReturn.documentHeaderId + bankReturnHeadquarters;
                    downloadLink.click();
                } catch (error) {
                    this.$_notificationMixin_error('Se ha producido un error', 'No hemos podido recuperar los asientos');
                }
                this.$_loadingMixin_hideLoading();
            },
            deleteConsignment() {
                swal({
                    title: '¿Desea eliminar la remesa?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                    cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                    reverseButtons: true
                }).then((response) => {
                    if (!!response.value) {
                        this.$_loadingMixin_showLoading();
                        deleteConsignment(this.bankReturn.uuid)
                            .then(() => {
                                this.$_notificationMixin_success('Operación completada', 'La remesa ha sido eliminada');
                                this.$_loadingMixin_hideLoading();
                                this.$router.push({path: '/accounting/consignments/list'});
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Error en la operación', 'No se ha podido eliminar la remesa');
                                this.$_loadingMixin_hideLoading();
                            });
                    }
                });
            }
        },
        watch: {
            'receiptToPrint.specifyExpeditionDate': function () {
                if (!this.receiptToPrint.specifyExpeditionDate) {
                    this.receiptToPrint.expeditionDate = null;
                }
            }
        }
    }
</script>

<style>
    .pointer {
        cursor: pointer;
    }

    .VueTables .VueTables__search {
        width: calc(66.6% + 20px);
    }

    .VueTables .VueTables__search .row {
        width: 100%;
    }

    .selected-receipts {
        padding: 7px;
        background-color: #41b883;
        color: #ffffff;
        border-radius: 5px;
    }

    .selected-receipts i {
        margin-right: 7px;
    }

    .selected-receipts .number {
        padding-left: 5px;
        font-weight: bold;
    }
</style>
